import BaseModel from '../../../model/BaseModel';
import Battery from '../../../model/Battery';
import Feature from '../../../strategy/Feature';

export default class MockBatteryFeature implements Feature {
  execute(): BaseModel {
    const min = Math.ceil(10);
    const max = Math.floor(100);
    return new Battery(Math.floor(Math.random() * (max - min)) + min);
  }
}
